import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Heart, User, Phone } from 'lucide-react';
export function QuickAccessRibbon() {
  const items = [{
    name: 'Book Appointment',
    icon: Calendar,
    href: '/booking'
  }, {
    name: 'Our Services',
    icon: Heart,
    href: '/services'
  }, {
    name: 'Meet Esther',
    icon: User,
    href: '/about'
  }, {
    name: 'Contact Us',
    icon: Phone,
    href: '/contact'
  }];
  return <div className="relative -mt-10 z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-412">
        {items.map(item => {
        const Icon = item.icon;
        return <Link key={item.name} to={item.href} className="group flex flex-col items-center justify-center p-5 rounded-xl bg-white shadow-soft hover:shadow-soft-lg hover:-translate-y-1 transition-all duration-300 min-h-[110px] border border-charcoal/5" data-id="element-413">
              <div className="w-12 h-12 rounded-xl bg-olive text-white flex items-center justify-center mb-3 group-hover:bg-gold transition-colors shadow-sm" data-id="element-414">
                <Icon size={24} strokeWidth={2} data-id="element-415" />
              </div>
              <span className="text-sm font-bold text-charcoal text-center leading-tight group-hover:text-olive transition-colors" data-id="element-416">
                {item.name}
              </span>
            </Link>;
      })}
      </div>
    </div>;
}